// removed by extract-text-webpack-plugin
module.exports = {"tag":"index__tag___2Ljrj","disabled":"index__disabled___2xUDc"};


//////////////////
// WEBPACK FOOTER
// ./src/views/ReportSetup/components/LeftSider/index.less
// module id = 1670
// module chunks = 3